import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaInstagram, FaClock } from 'react-icons/fa';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="bg-[#eee1ca] text-black">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <img
              src="/jana-marrakech-logo.png"
              alt="Jana Marrakech"
              className="h-16 mb-4"
            />
            <p className="text-black mb-4">
              {t('footer.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold text-[#72201e] mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-black hover:text-[#72201e] transition">
                  {t('footer.footerHome')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-black hover:text-[#72201e] transition">
                  {t('footer.footerAbout')}
                </Link>
              </li>
              <li>
                <Link to="/menu" className="text-black hover:text-[#72201e] transition">
                  {t('footer.footerMenu')}
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-black hover:text-[#72201e] transition">
                  {t('footer.footerGallery')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-black hover:text-[#72201e] transition">
                  {t('footer.footerContact')}
                </Link>
              </li>
              <li>
                <Link to="/reservation" className="text-black hover:text-[#72201e] transition">
                  {t('footer.footerReservation')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold text-[#72201e] mb-4">{t('footer.contact')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <FaMapMarkerAlt className="text-[#72201e] mt-1 mr-3 flex-shrink-0" />
                <span className="text-black whitespace-pre-line">
                  {t('footer.addressText')}
                </span>
              </li>
              <li className="flex items-center">
                <FaPhone className="text-[#72201e] mr-3" />
                <a href="tel:+212644005467" className="text-black hover:text-[#72201e] transition">
                  +2126 44 00 54 67
                </a>
              </li>
              <li className="flex items-center">
                <FaEnvelope className="text-[#72201e] mr-3" />
                <a href="mailto:reservation@janamarrakech.com" className="text-black hover:text-[#72201e] transition">
                  reservation@janamarrakech.com
                </a>
              </li>
            </ul>
          </div>

          {/* Hours & Social */}
          <div>
            <h3 className="text-xl font-bold text-[#72201e] mb-4">{t('footer.hours')}</h3>
            <div className="flex items-start mb-4">
              <FaClock className="text-[#72201e] mt-1 mr-3 flex-shrink-0" />
              <div className="text-black">
                <p className="font-semibold">{t('footer.mondayFriday')}</p>
                <p>18H00 - 01H00</p>
                <p className="font-semibold mt-2">{t('footer.weekend')}:</p>
                <p>18H00 - 03H00</p>
              </div>
            </div>
            <div className="mt-6">
              <h4 className="text-[#72201e] font-bold mb-3">{t('footer.followUs')}</h4>
              <div className="flex space-x-4">
                <a
                  href="https://www.facebook.com/Yamakanmarrakech/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#72201e] p-3 rounded-full hover:bg-red-text-[#72201e] transition transform hover:scale-110"
                  aria-label="Facebook"
                >
                  <FaFacebook className="text-2xl text-[#eee1ca]" />
                </a>
                <a
                  href="https://www.instagram.com/janamarrakech"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-[#72201e] p-3 rounded-full hover:bg-red-text-[#72201e] transition transform hover:scale-110"
                  aria-label="Instagram"
                >
                  <FaInstagram className="text-2xl text-[#eee1ca]" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-marrakech-clay">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm text-black gap-4">
            <p>&copy; {new Date().getFullYear()} Jana Marrakech. {t('footer.allRightsReserved')}</p>
            <p>
              {t('footer.developedBy')}{' '}
              <a
                href="https://aynnaka.ma/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#72201e] hover:text-marrakech-terracotta transition font-bold"
              >
                Aynnaka
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

